<template>
  <div>
    <div class="div-main">
      <div :class="`div-circle ${s[0]}`" @click="click(0)">0</div>
      <div :class="`div-circle ${s[1]}`" @click="click(1)">1</div>
      <div :class="`div-circle ${s[2]}`" @click="click(2)">2</div>
      <div :class="`div-circle ${s[3]}`" @click="click(3)">3</div>
      <div :class="`div-circle ${s[4]}`" @click="click(4)">4</div>
      <div :class="`div-circle ${s[5]}`" @click="click(5)">5</div>
      <div :class="`div-circle ${s[6]}`" @click="click(6)">6</div>
      <div :class="`div-circle ${s[7]}`" @click="click(7)">7</div>
      <div :class="`div-circle ${s[8]}`" @click="click(8)">8</div>
      <div :class="`div-circle ${s[9]}`" @click="click(9)">9</div>
      <div :class="`div-circle ${s[10]}`" @click="click(10)">10</div>
    </div>
    <answer-required-field v-if="!isvalid"></answer-required-field>
  </div>
</template>

<script>
import AnswerRequiredField from "./AnswerRequiredField";
export default {
  components: {
    AnswerRequiredField,
  },
  props: {
    required: Boolean
  },
  data() {
    return {
      isvalid: true,
      val: -1,
      s: [],
    };
  },
  methods: {
    value() {
      return { value: this.val };
    },
    isNegative() {
      return this.value().value < 7 && this.value().value >= 0;
    },
    isValid() {
      return this.required ? (this.val >= 0 ? true : false) : true;
    },
    validate() {
      this.isvalid = this.isValid();
      return this.isvalid;
    },
    onChange() {
      this.isvalid = true;
      this.$emit("changed", this.value());
    },
    click(id) {
      for (var i = id; i <= 10; i++) this.$set(this.s, i, "silver");

      let cls;
      if (id <= 6) cls = "red";
      else if (id <= 8) cls = "orange";
      else cls = "green";

      for (var i = 0; i <= id; i++) {
        this.s[i] = cls;
      }

      this.val = id;

      this.isvalid = true;
      this.$emit("changed", this.value());
    },
  },
  mounted() {
    this.s = [];
    for (var i = 0; i <= 10; i++) this.s.push("silver");
  },
};
</script>

<style>
.div-main {
  display: flex;
  padding-bottom: 10px;
}
.div-circle {
  border: 2px solid lightgray;
  border-radius: 100% ;
  height: 26px;
  width: 26px;
  text-align: center;
  cursor: pointer;
  margin-right: 3px;
  font-size: 12px;
  font-weight: 400;
  padding-top: 0px;
  user-select: none;
}
.red {
  background-color: #ff5252;
  color: white;
  border: 2px solid #ff5252;
}
.orange {
  background-color: orange;
  color: white;
  border: 2px solid orange;
}
.green {
  background-color: #00c853;
  color: white;
  border: 2px solid #00c853;
}
.silver {
  background-color: white;
  color: black;
  border: 2px solid #e0e0e0;
}
</style>